import React from 'react';
import { HOURS_IN_DAY, TIMEZONE_OPTIONS } from './baziConfig';

export default function BaziInputForm({
  t,
  birthDate,
  birthHour,
  timezoneOffsetMinutes,
  gender,
  highlightDescription,
  formatTimezoneOffset,
  onBirthDateChange,
  onBirthHourChange,
  onTimezoneChange,
  onGenderChange
}) {
  return (
    <div className="bazi-input-grid">
      <div>
        <label className="bazi-label" htmlFor="bazi-birth-date">{t.birthDateLabel}</label>
        <input
          id="bazi-birth-date"
          type="date"
          value={birthDate}
          onChange={(event) => onBirthDateChange(event.target.value)}
          className="bazi-input"
        />
      </div>
      <div>
        <label className="bazi-label" htmlFor="bazi-birth-hour">{t.birthHourLabel}</label>
        <select
          id="bazi-birth-hour"
          value={birthHour}
          onChange={(event) => onBirthHourChange(Number(event.target.value))}
          className="bazi-input"
        >
          {Array.from({ length: HOURS_IN_DAY }, (_, hour) => (
            <option key={hour} value={hour}>{hour}:00 - {hour}:59</option>
          ))}
        </select>
      </div>
      <div>
        <label className="bazi-label" htmlFor="bazi-timezone">{t.timezoneLabel}</label>
        <select
          id="bazi-timezone"
          value={timezoneOffsetMinutes}
          onChange={(event) => onTimezoneChange(Number(event.target.value))}
          className="bazi-input"
        >
          {TIMEZONE_OPTIONS.map((offset) => (
            <option key={offset} value={offset}>{formatTimezoneOffset(offset)}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="bazi-label" htmlFor="bazi-gender">{t.genderLabel}</label>
        <select
          id="bazi-gender"
          value={gender}
          onChange={(event) => onGenderChange(event.target.value)}
          className="bazi-input"
        >
          <option value="male">{t.genderOptions?.male}</option>
          <option value="female">{t.genderOptions?.female}</option>
        </select>
      </div>
      <div className="bazi-highlight-box">
        <p className="bazi-highlight-title">{t.highlightTitle}</p>
        <p className="bazi-highlight-desc">{highlightDescription}</p>
      </div>
    </div>
  );
}
